import { render } from "./NewReportTemplate.vue?vue&type=template&id=200c0685&scoped=true"
import script from "./NewReportTemplate.vue?vue&type=script&lang=js"
export * from "./NewReportTemplate.vue?vue&type=script&lang=js"

import "./NewReportTemplate.vue?vue&type=style&index=0&id=200c0685&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-200c0685"]])

export default __exports__